import { useState } from 'react'

import { Grid, Typography } from '@material-ui/core'
import { DatePicker } from '@material-ui/pickers'
import { Controller, useForm } from 'react-hook-form'
import moment from 'moment'

import useSnackbar from 'hooks/useSnackbar'

import { BaseDialog, LoadingFeedback } from 'components'
import * as service from 'service'
import helpers from 'helpers'

const ExportConciliationPaymentsDialog = ({ open, setOpen }) => {
  const [isLoading, setIsloading] = useState(false)
  const snackbar = useSnackbar()

  const { control, handleSubmit, errors } = useForm({
    defaultValues: {
      initialDate: moment().format('YYYY-MM-DD'),
      finalDate: moment().format('YYYY-MM-DD'),
    },
  })

  const onSubmit = async (data) => {
    setIsloading(true)
    try {
      const initialDate = (data.initialDate = moment(data.initialDate).format(
        'YYYY-MM-DD',
      ))
      const finalDate = (data.finalDate = moment(data.finalDate).format(
        'YYYY-MM-DD',
      ))

      await service.dponet.paymentOrders.conciliation({
        paymentOrder: {
          initialDate,
          finalDate,
        },
      })

      snackbar.open({
        message:
          'Relatório de conciliação gerado com sucesso! aguarde o e-mail com o anexo.',
        variant: 'success',
      })
      setOpen(false)
    } catch (error) {
      snackbar.open({
        message:
          helpers.formatters.errorMessage(error?.response?.data?.error) ||
          'Falha na geração do relatório!',
        variant: 'error',
      })
    } finally {
      setIsloading(false)
    }
  }

  return (
    <>
      <LoadingFeedback open={isLoading} />
      <BaseDialog
        formRef="export_conciliation"
        open={open}
        setOpen={setOpen}
        title="Exportar Conciliação"
        closeButtonText="Fechar"
        actionButtonText="Exportar"
      >
        <form id="export_conciliation" onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Typography variant="body1">
                Será considerada a data de confirmação do pagamento pelo
                intermediador e, para cobranças via cartão, a data de crédito.
              </Typography>
            </Grid>
            <Grid item xs={12}>
              <Controller
                as={
                  <DatePicker
                    label="Data Início"
                    color="primary"
                    format="DD/MM/yyyy"
                    variant="outlined"
                    error={!!errors.initialDate}
                    helperText={errors?.initialDate?.message}
                    fullWidth
                    required
                  />
                }
                control={control}
                name="initialDate"
                mode="onBlur"
              />
            </Grid>
            <Grid item xs={12}>
              <Controller
                as={
                  <DatePicker
                    label="Data Final"
                    color="primary"
                    format="DD/MM/yyyy"
                    variant="outlined"
                    error={!!errors.finalDate}
                    helperText={errors?.finalDate?.message}
                    fullWidth
                    required
                  />
                }
                control={control}
                name="finalDate"
                mode="onBlur"
              />
            </Grid>
          </Grid>
        </form>
      </BaseDialog>
    </>
  )
}

export default ExportConciliationPaymentsDialog
